import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import '../styles/Payment.css';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from "react-router-dom";

function Payment(props) {
 return (
     <div>
         <p>yoooo</p>
     </div>
 )
}

export default Payment;